"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPlaceTemplate = exports.placeComponent = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var Breadcrumb_1 = require("@/pages/search/components/Breadcrumb");
var Signup_1 = require("@/pages/common/components/Signup");
var Contact_1 = require("@/pages/common/components/contact/Contact");
var ExistingLogin_1 = require("@/pages/search/components/ExistingLogin");
var PlaceGalleryPop_1 = require("@/pages/place/components/PlaceGalleryPop");
var Bigpopup_1 = require("@/pages/common/components/Bigpopup");
var PlaceStickyTopBar_1 = require("@/pages/place/components/PlaceStickyTopBar");
var PlaceProps_1 = require("@/pages/place/components/PlaceProps");
var Enquire_1 = require("@/pages/common/components/Enquire");
var Recapture_1 = require("@/pages/search/components/Recapture");
var Testimonial_1 = require("@/pages/common/components/Testimonial");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var PlaceFaq_1 = require("@/pages/place/components/PlaceFaq");
var PlaceVideoPop_1 = require("@/pages/place/components/PlaceVideoPop");
var marked_1 = require("marked");
exports.placeComponent = function (props) {
    return (
    // stickymenu props is for hiding the menu when scrolling down in desktop view, since there is a sticky bar for placeComponent  
    React.createElement(PublicPage_1.default, { stickyMenu: false },
        React.createElement("div", { id: "place" },
            React.createElement("div", { className: "l-building__breadcrumb" },
                React.createElement("div", { className: "l-section" },
                    React.createElement("div", { className: "l-container l-container--lr  u-mobile-hidden l-pad-top l-pad--1half t--darker l-container--lg" },
                        React.createElement(Breadcrumb_1.default, null)))),
            React.createElement(props.topFragment, __assign({}, props)),
            React.createElement("div", { id: "stickymenu", className: "c-sticky-menu" },
                React.createElement(PlaceStickyTopBar_1.placeStickyTopBar, __assign({}, props)),
                React.createElement("div", { className: "" },
                    React.createElement(props.fragment, __assign({}, props)),
                    React.createElement(Contact_1.default, { mobileHidden: false, customText: props.customContactMarkdown ? marked_1.marked.parse(props.customContactMarkdown) : null }),
                    React.createElement(Testimonial_1.default, null),
                    props.faqs && props.faqs.length ? React.createElement(PlaceFaq_1.default, null) : null),
                React.createElement(PlaceGalleryPop_1.placeGalleryPop, __assign({}, props)),
                React.createElement(PlaceVideoPop_1.default, __assign({}, props)))),
        React.createElement(Signup_1.default, null),
        React.createElement(ExistingLogin_1.default, null),
        React.createElement(Enquire_1.default, null),
        React.createElement(Bigpopup_1.default, null),
        React.createElement(Recapture_1.default, null),
        React.createElement(ServerSideSchema_1.default, null)));
};
exports.withPlaceTemplate = function (fragment, topFragment) {
    var memoFragment = React.memo(fragment);
    var memoTopFragment = React.memo(topFragment);
    var withPlaceFragment = function (c) { return function (props) {
        return c(__assign(__assign({}, props), { fragment: memoFragment, topFragment: memoTopFragment }));
    }; };
    return react_redux_1.connect(PlaceProps_1.mapStateToProps, PlaceProps_1.mapDispatchToProps)(withPlaceFragment(exports.placeComponent));
};
